import React from "react";

interface BadgeProps {
  subject: string;
  badge: string;
  name1: string;
  name2: string;
  name3: string;
  count: number;
  rate: number;
}

const Badge: React.FC<BadgeProps> = ({
  subject,
  badge,
  name1,
  name2,
  name3,
  count,
  rate,
}) => {
  const overlayClasses =
    badge === "true"
      ? ""
      : "absolute inset-0 w-full h-full rounded-full bg-gray-700 opacity-50";

  return (
    <div className="relative flex items-center justify-center w-20 h-20 rounded-full border-gray-300 ">
      <div className={overlayClasses}></div>

      <div
        className={`flex flex-col items-center justify-center w-20 h-20 rounded-full ${
          count > 5000
            ? "bg-yellow-500"
            : count > 1000
            ? "bg-pink-500"
            : "bg-blue-500"
        } text-white font-bold transition-opacity duration-300`}
      >
        {name2 === null ? (
          "만료됨"
        ) : (
          <div>
            {" "}
            <div className="text-sm">
              {name2 ? (name2.length > 5 ? name2.slice(0, 4) : name2) : ""}
            </div>
            <div className="text-xs">
              {name3 ? (name3.length > 5 ? name3.slice(0, 4) : name3) : ""}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Badge;
